import React from "react";
import "../styles/aviso.css";

export default function AvisoLegalSEOdigital() {
  return (
    <section className="legal-container">
      <h1>Aviso Legal — SEO Digital</h1>

      <p>
        El presente Aviso Legal regula el uso del sitio web, plataformas y
        servicios tecnológicos provistos por <strong>SEO Digital</strong>,
        empresa dedicada al desarrollo de software a medida, soluciones cloud,
        automatización, inteligencia artificial y plataformas digitales para
        empresas.
      </p>

      <h2>1. Identificación del titular</h2>
      <ul>
        <li>Denominación comercial: SEO Digital</li>
        <li>Actividad: Desarrollo de software a medida</li>
        <li>Sede principal: República Argentina</li>
         
        <li>Email de contacto: administracion@seodigital.net</li>
        <li>Sitio web: https://seodigital.net</li>
      </ul>

      <h2>2. Marco normativo aplicable</h2>
      <p>
        SEO Digital cumple con la normativa de protección de datos y servicios
        digitales aplicable según jurisdicción:
      </p>
      <ul>
        <li>Ley Argentina 25.326 de Protección de Datos Personales</li>
        <li>Reglamento (UE) 2016/679 — RGPD</li>
        <li>Ley de Servicios de la Sociedad de la Información (UE)</li>
        <li>Normativas de comercio electrónico aplicables</li>
      </ul>

      <h2>3. Naturaleza de los servicios</h2>
      <p>
        SEO Digital provee servicios de desarrollo de software, plataformas,
        APIs, integraciones, sistemas a medida, soluciones cloud, automatización
        y productos tecnológicos personalizados para clientes corporativos.
      </p>

      <h2>4. Condiciones de uso</h2>
      <p>
        El acceso al sitio implica aceptación de las presentes condiciones.
        El usuario se compromete a utilizar los servicios de forma legal,
        responsable y conforme a la normativa vigente.
      </p>

      <h2>5. Propiedad intelectual</h2>
      <p>
        Todo el código, arquitectura, diseño, documentación técnica y
        componentes desarrollados por SEO Digital son propiedad intelectual de
        la empresa o del cliente según contrato específico. Queda prohibida su
        reproducción o distribución sin autorización expresa.
      </p>

      <h2>6. Confidencialidad y proyectos</h2>
      <p>
        Todos los proyectos se desarrollan bajo acuerdos de confidencialidad
        (NDA). La información técnica, comercial y los datos tratados en
        proyectos son considerados confidenciales.
      </p>

      <h2>7. Infraestructura cloud</h2>
      <p>
        Los servicios pueden operar sobre infraestructuras de terceros como
        AWS, Google Cloud, Vercel u otros proveedores equivalentes, que cumplen
        estándares internacionales de seguridad.
      </p>

      <h2>8. Responsabilidad técnica</h2>
      <p>
        SEO Digital no será responsable por interrupciones causadas por
        terceros, proveedores cloud, redes, integraciones externas o mal uso
        por parte del cliente o usuarios finales.
      </p>

      <h2>9. Datos personales</h2>
      <p>
        El tratamiento de datos se rige por la Política de Privacidad. Los
        titulares pueden ejercer sus derechos ante la autoridad de aplicación
        correspondiente (AAIP en Argentina o AEPD en España).
      </p>

      <h2>10. Subcontratación tecnológica</h2>
      <p>
        SEO Digital podrá utilizar subprocesadores tecnológicos para la
        prestación del servicio bajo contratos de confidencialidad y protección
        de datos.
      </p>

      <h2>11. Jurisdicción</h2>
      <p>
        Para controversias se aplicará la legislación de la República
        Argentina, sin perjuicio de normativas locales aplicables en España o
        Estados Unidos según el servicio contratado.
      </p>

      <h2>12. Actualizaciones</h2>
      <p>
        SEO Digital podrá modificar este Aviso Legal en cualquier momento para
        adaptarlo a cambios técnicos o normativos.
      </p>
    </section>
  );
}
